// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"1435bef1","101":"7a588e0f","261":"aaf195ef","575":"e1c29191","787":"881be0f8","873":"e0dd73ed","979":"77212e10"}[chunkId] + ".chunk.js";
};